import { isPrimitive } from 'util';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

import { FormControl, FormGroup } from '@angular/forms';
import { Config } from 'app/config.const';

@Component({
  selector: 'app-login',
  templateUrl: './login.html',
  styleUrls: ['./login.css'],
  providers: []
})
export class LoginComponent {

  formGroup = new FormGroup({
    username: new FormControl(),
    password: new FormControl()
  });
  problem: string | false;
  readonly reason$: Observable<string>;

  private readonly onError: (error) => void;

  constructor(
    route: ActivatedRoute,
    private httpClient: HttpClient,
    private router: Router
  ) {

    const reasonSubject = new Subject();
    this.onError = (error) => {
      if (isPrimitive(error)) {
        reasonSubject.next(error);
      } else if ('error' in error && error.error) {
        reasonSubject.next(error.error);
      } else {
        console.error(error);
      }
    }

    // http://localhost:4200/login?c=0a87a9c65f2fb3f31103704f5c02fce77932fdc7&r=xxx

    let params = location.search.substring(1).split("&");
    let access_token = '';
    let refresh_token = '';
    let specializzazioneId = '';
    let medicoCF = '';

    for (let i = 0; i < params.length; i++) {
      let item = params[i].split("=");
      if (item[0] === 'c') {
        access_token = item[1];
      } else if (item[0] === 'r') {
        refresh_token = item[1];
      } else if (item[0] === 's') {
        specializzazioneId = item[1];
      } else if (item[0] === 'm') {
        medicoCF = item[1];
      }
    }

    if (!access_token) {
      return;
    }

    // eseguo una richiesta al server per prendere il cookie server

    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + access_token
    });

    let body = {
      "grant_type": "verify",
      "token": access_token,
      "specializzazioneId": specializzazioneId,
      "medicoCF": medicoCF
    };

    console.log(`Richiesta login a ${Config.baseURL}/auth`);

    // pulisco i dati del client prima del login
    localStorage.removeItem('auth-cookie-shortcut');

    this.httpClient.post(`${Config.baseURL}/auth`, body, {
      // withCredentials: true,
      observe: "response",
      headers: headers
    }).subscribe((result: any) => {
      if (result.body.error) {
        throw new Error("Error during login: " + result.body.error);
      }

      console.log('result.body', result.body)

      // salvo nel localStorage il cookie per comodità
      localStorage.setItem('auth-cookie-shortcut', JSON.stringify(result.body));

      // estraggo le domande del medico per il paziente
      this.httpClient.get(`${Config.baseURL}/domande-appuntamento?access_token=${access_token}`).subscribe(response => {
        localStorage.setItem('agenda.domande-medico', JSON.stringify(response))
        
        location.href = "agende/";
      })

    },
      err => {
        alert('Errore: ' + JSON.stringify(err));
        console.error("Errore auth silente agenda client");
        console.error(err);
      });
  }

  login(route: string = "agende") {
    debugger
    // FIXME: rimuovere questo metodo
    console.log('non dovrei essere qua');
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.ts